import Interaction from "./Interaction";
import { InteractionType } from "./Interaction";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import SwitchNodePreview from "../../features/sequence/node_previews/SwitchNodePreview";

export interface SwitchCase {
  id: string;
  match: string | number | boolean;
}

export interface ISwitch extends Interaction {
  variable: string;
  cases: SwitchCase[];
}

export const SWITCH_DEFAULT_HANDLE_ID = "switch-default";

export const switchInteraction = (): InteractionFactoryEntity => {
  const create = (getKeys: (amount: number) => string[]): ISwitch => {
    return {
      id: GetNewGuid(),
      name: "Switch",
      type: InteractionType.Switch,
      variable: "",
      cases: [
        {
          id: GetNewGuid(),
          match: "",
        },
      ],
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction,
  ): ISwitch => {
    const casted = interaction as ISwitch;
    const cases = casted.cases ?? [];
    let hasCaseIdChanges = false;

    const migratedCases = cases.map((switchCase) => {
      if (switchCase.id) {
        return switchCase;
      }
      hasCaseIdChanges = true;
      return {
        ...switchCase,
        id: GetNewGuid(),
      };
    });

    if (!hasCaseIdChanges) {
      return casted;
    }

    return {
      ...casted,
      cases: migratedCases,
    };
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
    replaceKey: (from: string, to: string) => void,
  ): ISwitch => {
    const original = interaction as ISwitch;
    return {
      id: GetNewGuid(),
      name: "Switch",
      type: InteractionType.Switch,
      variable: original.variable,
      cases: original.cases.map((switchCase) => ({
        id: GetNewGuid(),
        match: switchCase.match,
      })),
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string,
  ): string[] => {
    const warnings: string[] = [];
    return warnings;
  };

  const filterType = "Switch";

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string,
    ) => SearchResultData[],
  ): SearchResultData[] => {
    return getMatchingResults(
      [interaction.name],
      takeName,
      interaction,
      filterType,
    );
  };

  const validateError = (interaction: Interaction): string[] => {
    const casted = interaction as ISwitch;
    const errors: string[] = [];

    if (!casted.variable) {
      errors.push("Please select a variable to compare");
    }

    return errors;
  };

  return {
    View: <div>Switch Node</div>,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <SwitchNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    Create: create,
    FilterType: filterType,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateError,
  };
};
